import * as tsx from 'vue-tsx-support';
import { Maybe } from '@codegrade/maybe';
import CgLogo from '@/components/CgLogo';
import Login from '@/components/Login';
import PageTitle from '@/components/PageTitle';
import * as models from '@/models';
import router from '@/router';
import { TenantsStore, UIPrefsStore, UserStore } from '@/store';
import * as utils from '@/utils';
export default tsx.component({
    name: 'login',
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        darkMode() {
            return UIPrefsStore.darkMode();
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        tenantId() {
            return this.$route.params.tenantId;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        tenant() {
            return Maybe.fromNullable(this.tenantId)
                .chain(TenantsStore.getTenant())
                .altLazy(() => TenantsStore.allTenants()
                .filter(x => x.length === 1)
                .map(x => x[0]));
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        redirect() {
            return this.$router
                .getQuery('redirect')
                .filter(r => utils.urlSameOrigin(r))
                .map(r => utils.stripURLOrigin(r));
        },
        /** @returns The title to set. */
        pageTitle() {
            return this.tenant.mapOrDefault(tenant => `Login for ${tenant.name}`, 'Login');
        },
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        doSamlLogin(tenant) {
            const next = this.redirect.map(r => router.resolve(r).route.fullPath).extract();
            const query = { next };
            const url = utils.buildUrl(models.SSOProvider.loginUrlFromTenant(tenant), { query });
            window.location.replace(url);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        onLogin() {
            this.$router.replace(this.redirect.orDefault({ name: 'home' }));
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    mounted() {
        if (UserStore.loggedIn()) {
            this.redirect.ifJust(route => {
                this.$router.replace(route);
            });
        }
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        return (<div class="login">
                <div class="login-wrapper" style={{ margin: '2rem auto' }}>
                    <CgLogo inverted={!this.darkMode} class="standalone-logo"/>
                    <PageTitle pageTitle={this.pageTitle}/>

                    <Login class="login" style={{ maxWidth: '25rem', margin: '0 auto' }} onLogin={this.onLogin} onSamlLogin={this.doSamlLogin} tenantId={this.$route.params.tenantId} initialUsername={this.$router.getQuery('username').extract()}/>
                </div>
            </div>);
    },
});
